import React, {useEffect, useState} from "react";
import Swal from "sweetalert2";
import { Link, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";

// Material-UI
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import { InputAdornment, IconButton, makeStyles } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import IconMasuk from "@material-ui/icons/InputRounded";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
// Gambar
import GambarLogin from "../../../assets/image/backgroundLogin.jpg";
import LogoKSR from "../../../assets/image/logoKSR.jpg";
// Components
import ModalDaftar from "../components/ModalDaftar";
import Copyright from "../components/Copyright";
// Axios
// import axios from 'axios';
//service
import loginService from '../services/loginService';

const useStyle = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  image: {
    backgroundImage: `url(${GambarLogin})`,
    backgroundRepeat: "no-repeat",
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.grey[50]
        : theme.palette.grey[900],
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  logo: {
    height: "50px",
    margin: theme.spacing(2, 1),
  },
  paper: {
    margin: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  captha: {
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(2, 0),
  },
  link: {
    textDecoration: "none",
    display: "flex",
    justifyContent: "center"
  }
}));

const BackgroundLogin = ({ classes }) => {
  return <Grid item xs={false} sm={4} md={7} className={classes.image} />;
};

const FormLogin = ({ classes }) => {
  const { register, handleSubmit } = useForm();
  const history = useHistory();
  const onSubmit = async(data) => {
    let bodyRequest = {
      email: data.email,
      password: data.password,
      jawaban: data.captha,
      kode: showCaptcha.kode
    }

    try {
      var login = await loginService.login(bodyRequest)

      let redirect

      switch(login.data.data.tahap) {
        case "0":
          redirect = '/user/validasi-pembayaran';
          break;
        case "1":
          redirect = '/user/validasi-pembayaran';
          break;
        case "2":
          redirect = '/user/validasi-biodata'
          break;
        case "3":
          redirect = '/user/validasi-berkas'
          break;
        case "4":
          redirect = '/user/validasi-berkas'
          break;
        default:
          redirect = '/user/beranda'
          break;
      }

      localStorage.setItem("token", login.data.data.token);
      localStorage.setItem("id_user", login.data.data.id);
      localStorage.setItem("tahap", login.data.data.tahap);

      return (
        Swal.fire({
          icon: "success",
          title: "Berhasil Masuk!",
          text: "Selamat Datang Calon Anggota Baru ^_^",
        }),
        history.push(redirect)
        );
        
      } catch(e) {
        return (
          Swal.fire({
            icon: "error",
            title: "Gagal login!",
            text: e.response.data.meta.message || e.message
          }).then(result => {
            loginService.getCaptcha()
              .then((response) => {
                setCaptcha({
                  soal: response.data.data.soal,
                  jawaban: response.data.data.jawaban,
                  kode: response.data.data.kode
                })
              })
              .catch((error) => {
                console.error("error: ", error)
              })
          })
        )
    }

    /*
    if (
      data.email === "user1@unj.ac.id" &&
      data.password === "1234" &&
      data.captha === "2"
    ) {
      return (
        Swal.fire({
          icon: "success",
          title: "Berhasil Masuk!",
          text: "Selamat Datang Calon Anggota Baru ^_^",
        }),
        history.push('/user/validasi-pembayaran')
      );
    } else if (
      data.email === "user2@unj.ac.id" &&
      data.password === "1234" &&
      data.captha === "2"
    ) {
      return (
        Swal.fire({
          icon: "success",
          title: "Berhasil Masuk!",
          text: "Selamat Datang Calon Anggota Baru ^_^",
        }),
        history.push('/user/validasi-biodata')
      );
    } else if (
      data.email === "user3@unj.ac.id" &&
      data.password === "1234" &&
      data.captha === "2"
    ) {
      return (
        Swal.fire({
          icon: "success",
          title: "Berhasil Masuk!",
          text: "Selamat Datang Calon Anggota Baru ^_^",
        }),
        history.push('/user/beranda')
      );
    } else {
      return Swal.fire({
        icon: "error",
        title: "Gagal Masuk!",
        text: "Akun atau Jawaban yang anda masukkan salah T_T",
      });
    }
    */
  };

  const [showPassword, setShowPassword] = useState(false);
  const [showCaptcha, setCaptcha] = useState({soal: "", jawaban: "", kode: ""})
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  useEffect(() => {
    loginService.getCaptcha()
    .then((response) => {
      setCaptcha({
        soal: response.data.data.soal,
        jawaban: response.data.data.jawaban,
        kode: response.data.data.kode
      })
    })
    .catch((error) => {
      console.error("error: ", error)
    })
  }, [setCaptcha])

  return (
    <Grid item xs={12} sm={8} md={5} elevation={6} className={classes.formContainer}>
      <div className={classes.paper}>
        <img src={LogoKSR} alt="LOGO KSR" className={classes.logo}></img>
        <Typography component="h1" variant="h5" align="center">
          {"SISTEM INFORMASI"}
        </Typography>
        <Typography component="h1" variant="h5" align="center">
          {"PENERIMAAN CALON ANGGOTA BARU"}
        </Typography>
        <Typography component="h1" variant="h5" align="center">
          {"KSR PMI UNIT UNJ"}
        </Typography>
        <form
          className={classes.form}
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="email"
            name="email"
            inputRef={register({ required: true })}
            label="Email Address"
            type="email"
            variant="outlined"
            margin="normal"
            required
            fullWidth
            autoFocus
          />
          <TextField
            id="password"
            name="password"
            inputRef={register({ required: true })}
            label="Password"
            type={showPassword ? "text" : "password"}
            variant="outlined"
            margin="normal"
            required
            fullWidth
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <Alert className={classes.captha} severity="warning" variant="outlined">
            {showCaptcha.soal}
          </Alert>
          <TextField
            id="captha"
            name="captha"
            inputRef={register({ required: true })}
            label="Jawab"
            type="number"
            variant="outlined"
            margin="normal"
            required
            fullWidth
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
            size="large"
            fullWidth
            startIcon={<IconMasuk />}
          >
            {"MASUK"}
          </Button>
          <Divider />
          <ModalDaftar />
          <Box mt={2} mb={4}>
            <Link to="/lupa-password" className={classes.link}>
              <Button size="large" color="primary">
                {"Lupa Password"}
              </Button>
            </Link>
          </Box>
          <Box mt={2} mb={4}>
            <Copyright />
          </Box>
        </form>
      </div>
    </Grid>
  );
};

const LoginUser = () => {
  const classes = useStyle();
  return (
    <section id="user-login">
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <FormLogin classes={classes} />
        <BackgroundLogin classes={classes} />
      </Grid>
    </section>
  );
};
export default LoginUser;
